class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    /* CÆL : un clic sur le voile ou sur le fond de la recherche (hors champ et suggestions) referme */
    const t = event.target;
    if (!this.contains(t) || t.classList.contains('modal-overlay') || t.classList.contains('cael-sx__panel')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    clearTimeout(this.closingTimer);
    this.classList.remove('is-closing');
    /* CÆL : la place de la barre de défilement est gardée par cael-core.css (scrollbar-gutter), rien ne bouge */
    event.target.closest('details').setAttribute('open', true);
    this.raise(true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  /* CÆL : la recherche plein écran vit dans la section de l'en-tête, collante et posée au niveau 3 : ses enfants ne
     peuvent pas passer au-dessus d'un élément de page plus haut (barre de la Communauté, « ← Mon espace »…).
     Tant qu'elle est ouverte, la section de l'en-tête passe devant toute la page (assets/cael-search.css). */
  raise(on) {
    if (!this.classList.contains('cael-sx')) return;
    const host = this.closest('.shopify-section');
    if (host) host.classList.toggle('cael-sx-open', on);
  }

  close(focusToggle = true) {
    if (!this.isOpen() || this.classList.contains('is-closing')) return;
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    /* CÆL : un fondu bref avant de refermer (voir cael-menu.css), puis la page retrouve son défilement */
    const finish = () => {
      this.classList.remove('is-closing');
      this.detailsContainer.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      this.raise(false);
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return finish();
    this.classList.add('is-closing');
    this.closingTimer = setTimeout(finish, this.classList.contains('cael-sx') ? 420 : 180);
  }
}

customElements.define('details-modal', DetailsModal);
